import { jsx } from "react/jsx-runtime";
import React, { useMemo, useContext } from "react";
const ThisContext = React.createContext(null);
const LoadingContext = React.createContext(false);
function useThisContext() {
  const context = useContext(ThisContext);
  return (context == null ? void 0 : context.data) || null;
}
function useLoadingContext() {
  const context = useContext(LoadingContext);
  return context || false;
}
function ThisProvider({ data, isLoading = false, children }) {
  const thisValue = useMemo(() => ({ data }), [data]);
  return /* @__PURE__ */ jsx(ThisContext.Provider, { value: thisValue, children: /* @__PURE__ */ jsx(LoadingContext.Provider, { value: isLoading, children }) });
}
export {
  LoadingContext,
  ThisContext,
  ThisProvider,
  useLoadingContext,
  useThisContext
};
